import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  socket: null,
};

const getters = {
  socket: status => {
    return status.socket;
  },
};

const actions = {
  saveSocket({ commit }, data) {
    try {
      commit('saveSocket', data);
    } catch (e) {
      throw e;
    }
  },
};

const mutations = {
  saveSocket(state, data) {
    state.socket = data;
  },
};

const socket = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default socket;

export { socket };

